import Splide from '@splidejs/splide';

let imageVideoSlides = document.getElementsByClassName('image-video-slider');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < imageVideoSlides.length; i++) {
        let splide = new Splide(imageVideoSlides[i], {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            rewind: true,
            pagination: false,
            arrows: true,
            gap: 24,
            width: '100%'
        });

        let bar = splide.root.querySelector('.splide-progress-bar');

        splide.on('mounted move', function () {
            let end = splide.Components.Controller.getEnd() + 1;
            bar.style.width = String(100 * (splide.index + 1) / end) + '%';
        });

        splide.on('mounted', function () {
            let track = splide.root.querySelector('.splide__track');
            track.classList.add('hasOverflow');
        });

        splide.on('moved', function () {
            let videosUpload = document.querySelectorAll('.image-video-slider video');
            let videosYoutube = document.querySelectorAll('.image-video-slider [data-video]');

            // Pause all uploaded videos
            videosUpload.forEach((video, index) => {
                video.pause();
            });

            // Pause all youtube videos
            videosYoutube.forEach((video, index) => {
                video.parentElement.classList.remove('play');
                video.innerHTML = '<div class="play-button"></div>';
            });
        });

        splide.mount();
    }
});

let videos = document.querySelectorAll('.image-video-slider .item .play-button.upload');

videos.forEach(function (el) {
    el.addEventListener('click', function () {
        this.parentElement.classList.add('play');
        this.nextElementSibling.play();
    });
});

let videoElements = document.querySelectorAll('[data-video]');
videoElements.forEach(function (element) {
    element.addEventListener('click', function () {
        let parentElement = this.parentElement;
        let videoProvider = this.getAttribute('data-video-provider');
        let videoId = this.getAttribute('data-video-id');

        switch (videoProvider) {
            case 'youtube':
                this.innerHTML = '<iframe src="https://www.youtube.com/embed/' + videoId +
                    '?rel=0&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
                parentElement.classList.add('play');
                break;
            case 'vimeo':
                this.innerHTML = '<iframe src="https://player.vimeo.com/video/' + videoId +
                    '?autoplay=1" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
                let picture = parentElement.querySelector('picture');
                parentElement.classList.add('play');
                picture.classList.add('invisible');
                break;
        }
    });
});
